module.exports = __webpack_public_path__ + "img/laurel-high-angle.1906dc27.png";